










import { Vue, Component } from 'vue-property-decorator'

const config = {
  name: 'icon-bdd',
  components: {}
}

@Component(config)
export default class IconBdd extends Vue {}
